module.exports = __webpack_public_path__ + "static/media/BPI_8089616_1.4c8272c6.png";